import { CREATE, DELETE, UPDATE } from './actionsTypes'

export const actionToMethod = new Map([[CREATE, 'create'], [UPDATE, 'update'], [DELETE, 'delete']]);
